import { ENDPOINTS, callApi } from 'utils/api/callApi'
import { IGetMarkdownResponse } from '../../../types'

/**
 * Gets the Element Conversion Document as markdown
 * @method GET
 */
export const getElementConversionDocs = (): Promise<IGetMarkdownResponse> => {
  return callApi(
    {
      endpoint: ENDPOINTS.ediSelfServeBase,
      method: 'GET',
      group: 'element_conversion_docs',
      params: { name: 'default' },
    },
    { shouldCamelizeKeys: false }
  )
}

/**
 * Gets the Document Conversion docs as markdown
 * @method GET
 */
export const getDocumentConversionDocs = (): Promise<IGetMarkdownResponse> => {
  return callApi(
    {
      endpoint: ENDPOINTS.ediSelfServeBase,
      method: 'GET',
      group: 'document_conversion_docs',
      params: { name: 'default' },
    },
    { shouldCamelizeKeys: false }
  )
}

/**
 * Gets the JSON schema docs as markdown
 * @method GET
 */
export const getJSONSchemaDocs = (): Promise<IGetMarkdownResponse> => {
  return callApi(
    {
      endpoint: ENDPOINTS.ediSelfServeBase,
      method: 'GET',
      group: 'json_schema_docs',
      params: { name: 'default' },
    },
    { shouldCamelizeKeys: false }
  )
}
